import React, {useState, useEffect} from 'react';
import './Analytics.css';
import { observer } from 'mobx-react';
import Sidebar from '../../components/sidebar';
import Sidebar_new from '../../components/sidebar_for_user';
import Dataset from '../../components/dataset/index.js'
import Models from '../../components/models/index.js'
import GlobalState from "../../stores/GlobalState";
import PopupDeploymentAnalitics from '../../components/dataset/popup/popupDeploymentAnalitics.js';
import PopupAddDataset from '../../components/dataset/popup/popupAddDataset.js';
import PopupAttachment from '../../components/dataset/popup/popupAttachment';
import PopupDeleteModel from '../../components/models/popupDeleteModel';
import {Helmet} from "react-helmet";
import Mini from '../../components/mini/index.js'
import UserPool from '../../components/autorize/UserPool';
const Analytics= observer(() => {
    const [holdBlock, setholdBlock] = useState(true);
    const [datasegment, setDatasegment] = useState(1);
     const [user, setUser]=useState("");
    const changemenu = () =>{
        setholdBlock(false)
    }
    window.onbeforeunload = () => {
        setholdBlock(true)
    }
    const [langmenu, setLangmenu] = useState(localStorage.getItem("lang_site")||"en")
    const token = localStorage.getItem("token");
    useEffect(() => {
        const token = localStorage.getItem("token");
        if (token) {
            const cognitoUser = UserPool.getCurrentUser();
            setUser(cognitoUser.username)
        } 
    }, []);
    return (
        <>
        {
            langmenu=="de"?
            <Helmet>
                <title>Beinf.ai - your data-driven AI marketing talent that drives loyalty</title>
                <meta name="description" content="Beinf.ai — eine No-Code-Lösung für maschinelles Lernen. Entscheidungsfindung auf Basis einer tiefgehenden Analyse historischer Ereignisse und Prognosen." />
            </Helmet>
            :
            <Helmet>
                <title>Beinf.ai - your data-driven AI marketing talent that drives loyalty</title>
                <meta name="description" content="Beinf.ai — a no-code machine learning solution. Decision-making based on in-depth analysis of historical events and forecasting." />
            </Helmet>
        }
        {
            
                user=="admin"|| user=="gewgur"?
                <>
                    <Sidebar_new/>
                </>
                :
                <>
                    <Sidebar/>
                </>
            }
        <div className="segmentation models hold">
           
            <div className='body_segment'>
                <Models/>
                
            </div>
        </div>
        <Mini/>
        {GlobalState.ispopupaddAttachmentShowAnalitics?<PopupDeploymentAnalitics/>:<></>}
        {GlobalState.ispopupadddatasetShow?<PopupAddDataset/>:<></>}
        {GlobalState.ispopupaddAttachmentShow?<PopupAttachment/>:<></>}
        {GlobalState.ispopupdeleteModelShow ?<PopupDeleteModel/>:<></>}
        </>
    );
})

export default Analytics;

